import "./styles/index.scss"

import React from "react"
import { Provider } from "react-redux"
import ReactDOM from "react-dom/client"
import App from "./app"
import store from "./store"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <Provider store={store}>
    <App />
  </Provider>
)
